// extracted by mini-css-extract-plugin
module.exports = {"BeforeAuth":"BeforeAuth_BeforeAuth__1Cnwp","leftDiv":"BeforeAuth_leftDiv__2N9C7","rightDiv":"BeforeAuth_rightDiv__3K7aQ"};